import RandingStyle22 from "../../randing/RandingStyle22";

function Randing289({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <RandingStyle22
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/289/01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/289/02.gif`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/289/03.jpg`}
        img4Path={`${process.env.REACT_APP_CDN_BASE}/images/289/04.jpg`}
        formFieldColor="white"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton_small2.png`}
        companyName="본원"
        fixedDbColor="rgba(255, 255, 255, 0.8)"
        articleOption={true}
        benefitInfo={false}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing289;
